module.exports = __webpack_public_path__ + "img/1412439234.caa887f4.jpg";